<ion-app>
  <ion-menu [type]="'overlay'" swipeGesture="false" side="end" type="push" contentId="main">
    <ion-header>
      <ion-toolbar>
        <ion-item lines="none">
          <ion-avatar slot="start">
            <ion-img [src]="avatar"></ion-img>
          </ion-avatar>
          <ion-label><strong>{{username}}</strong></ion-label>
        </ion-item>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <ion-list>
        <ion-item (click)="navToRoute('/profile')">
          <ion-label>Perfil</ion-label>
        </ion-item>
        <ion-item (click)="navToRoute('/reset-password')">
          <ion-label>Cambiar Contraseña</ion-label>
        </ion-item>
        <ion-item (click)="navToRoute('/market')">
          <ion-label>Ideas</ion-label>
        </ion-item>

        <div class="flex flex-row justify-center items-center">
          <button type="button" (click)="signOut()"
            class="px-3 py-2 w-36 mt-6 text-sm font-medium text-center text-white bg-primary-700 rounded-full hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">Cerrar
            sesión</button>
        </div>
      </ion-list>
    </ion-content>

    <ion-footer class="ion-no-border">
      <ion-toolbar class="bg-white">
        <ion-item lines="none">
          <ion-title class="ion-text-center">
            <ion-img src="images/logo/logo.svg" alt="Profit4U" class="w-24 h-11"></ion-img>
          </ion-title>
        </ion-item>

        <div class="flex justify-center items-center py-4 bg-white">
          <ion-label class=" text-black pl-6">App V {{appVersion}}</ion-label>
        </div>

        <div class="flex flex-col justify-center items-center mb-3 bg-white">
          <label class="text-support text-dark">Conoce nuestros</label>
          <div class="flex items-center">
            <a class="ml-1 text-primary-500 hover:underline" (click)="terms()">Términos y condiciones
            </a>
          </div>
        </div>
      </ion-toolbar>
    </ion-footer>
  </ion-menu>

  <ion-router-outlet id="main" [swipeGesture]="false"></ion-router-outlet>
</ion-app>